"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RingCentralCall = exports.SUBSCRIPTION_CACHE_KEY = exports.events = void 0;
var events_1 = require("events");
var ringcentral_call_control_1 = require("ringcentral-call-control");
var Session_1 = require("./Session");
var userAgent_1 = require("./userAgent");
var utils_1 = require("./utils");
var events;
(function (events) {
    events["WEBPHONE_REGISTERED"] = "webphone-registered";
    events["NEW"] = "new";
    events["WEBPHONE_UNREGISTERED"] = "webphone-unregistered";
    events["WEBPHONE_REGISTRATION_FAILED"] = "webphone-registration-failed";
    events["CALL_CONTROL_READY"] = "call-control-ready";
    events["CALL_CONTROL_NOTIFICATION_REDY"] = "call-control-notification-ready";
    events["CALL_CONTROL_NOTIFICATION_ERROR"] = "call-control-notification-error";
    events["WEBPHONE_INVITE"] = "webphone-invite";
    events["WEBPHONE_INVITE_SENT"] = "webphone-invite-sent";
})(events = exports.events || (exports.events = {}));
exports.SUBSCRIPTION_CACHE_KEY = 'rc-call-subscription-key';
var RingCentralCall = /** @class */ (function (_super) {
    __extends(RingCentralCall, _super);
    function RingCentralCall(_a) {
        var webphone = _a.webphone, sdk = _a.sdk, subscriptions = _a.subscriptions, _b = _a.enableSubscriptionHander, enableSubscriptionHander = _b === void 0 ? true : _b, userAgent = _a.userAgent, callControlOptions = _a.callControlOptions;
        var _this = _super.call(this) || this;
        _this._subscriptionCacheKey = exports.SUBSCRIPTION_CACHE_KEY;
        _this._subscriptionEventFilters = [];
        _this._onWebPhoneSessionRing = function (webphoneSession) {
            _this.emit(events.WEBPHONE_INVITE, webphoneSession);
            var session = _this._getSessionFromWebphoneSession(webphoneSession);
            // @ts-ignore
            webphoneSession.__rc_direction = Session_1.directions.INBOUND;
            if (session) {
                session.setWebphoneSession(webphoneSession);
                return;
            }
            session = _this._onNewWebPhoneSession(webphoneSession);
            _this.emit(events.NEW, session);
        };
        _this._onWebPhoneSessionInviteSent = function (webphoneSession) {
            if (_this._webphoneInviteFromSDK) {
                return;
            }
            _this._onWebPhoneSessionInvite(webphoneSession);
        };
        _this._onNewTelephonySession = function (telephonySession, fromPreload) {
            if (fromPreload === void 0) { fromPreload = false; }
            var session = _this.sessions.find(function (s) { return s.telephonySessionId === telephonySession.id; });
            if (!session) {
                // find if there are session from initializing web phone session.
                var party_1 = telephonySession.party;
                if (party_1 && party_1.direction === Session_1.directions.OUTBOUND) {
                    session = _this.sessions.find(function (s) { return (!s.telephonySessionId &&
                        s.to.phoneNumber === party_1.to.phoneNumber &&
                        s.direction === Session_1.directions.OUTBOUND); });
                }
            }
            if (session) {
                session.setTelephonySession(telephonySession);
                return session;
            }
            session = new Session_1.Session({
                telephonySession: telephonySession,
            });
            var onSessionDisconnected = function () {
                _this._onSessionDisconnected(session);
                session.removeListener(Session_1.events.DISCONNECTED, onSessionDisconnected);
            };
            session.on(Session_1.events.DISCONNECTED, onSessionDisconnected);
            _this._sessions.push(session);
            if (!fromPreload) {
                _this.emit(events.NEW, session);
            }
            return session;
        };
        _this._onCallControlInitialized = function () {
            _this.callControl.sessions.forEach(function (telephonySession) {
                _this._onNewTelephonySession(telephonySession, true);
            });
            _this.emit(events.CALL_CONTROL_READY);
        };
        _this._onWebphoneRegistered = function () {
            if (!_this._webphoneRegistered) {
                _this._webphoneRegistered = true;
                _this.emit(events.WEBPHONE_REGISTERED);
            }
        };
        _this._onWebphoneUnregistered = function () {
            _this._webphoneRegistered = false;
            _this.emit(events.WEBPHONE_UNREGISTERED);
        };
        _this._onWebphoneRegistrationFailed = function (response, cause) {
            _this._webphoneRegistered = false;
            _this.emit(events.WEBPHONE_REGISTRATION_FAILED, response, cause);
        };
        _this._onSubscriptionCreateSuccess = function () {
            _this._callControlNotificationReady = true;
            _this.emit(events.CALL_CONTROL_NOTIFICATION_REDY);
            _this._sdk
                .cache()
                .setItem(_this._subscriptionCacheKey, _this._subscription.subscription());
        };
        _this._onSubscriptionCreateError = function () {
            _this._callControlNotificationReady = false;
            _this.emit(events.CALL_CONTROL_NOTIFICATION_ERROR);
            _this._sdk
                .platform()
                .loggedIn()
                .then(function (loggedIn) {
                if (loggedIn) {
                    _this._subscription
                        .reset()
                        .setEventFilters(_this._subscriptionEventFilters)
                        .register();
                }
            });
        };
        _this._onSubscriptionRenewFail = function () {
            _this._callControlNotificationReady = false;
            _this.emit(events.CALL_CONTROL_NOTIFICATION_ERROR);
            _this._sdk
                .platform()
                .loggedIn()
                .then(function (loggedIn) {
                if (loggedIn) {
                    _this._subscription
                        .reset()
                        .setEventFilters(_this._subscriptionEventFilters)
                        .register();
                }
            });
        };
        _this._onSubscriptionAutomaticRenewError = function () {
            _this._subscription.resubscribe();
        };
        _this.onNotificationEvent = function (msg) {
            // console.log(JSON.stringify(msg, null, 2));
            _this._callControl.onNotificationEvent(msg);
        };
        _this.loadSessions = function (sessions) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._callControl.loadSessions(sessions)];
                    case 1:
                        _a.sent();
                        this._callControl.sessions.forEach(function (session) {
                            _this._onNewTelephonySession(session, true);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.restoreSessions = function (sessions) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._callControl.restoreSessions(sessions)];
                    case 1:
                        _a.sent();
                        this._callControl.sessions.forEach(function (session) {
                            _this._onNewTelephonySession(session, true);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this._sessions = [];
        _this._webphoneRegistered = false;
        _this._callControlNotificationReady = false;
        _this._enableSubscriptionHander = enableSubscriptionHander;
        _this._sdk = sdk;
        _this._subscriptions = subscriptions;
        _this._userAgent = userAgent ? userAgent + " " + userAgent_1.USER_AGENT : userAgent_1.USER_AGENT;
        _this._callControlOptions = callControlOptions;
        _this.initCallControl(sdk);
        if (webphone) {
            _this.setWebphone(webphone);
        }
        return _this;
    }
    RingCentralCall.prototype.makeCall = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var webphoneSession, callParams, telephonySession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (params.type === 'webphone') {
                            if (!this.webphone) {
                                throw new Error('Web phone instance is required');
                            }
                            if (!this.webphoneRegistered) {
                                throw new Error('webphone is not registered');
                            }
                            this._webphoneInviteFromSDK = true; // avoid trigger _onWebPhoneSessionInvite twice
                            webphoneSession = this._webphone &&
                                this._webphone.userAgent.invite(params.toNumber, {
                                    fromNumber: params.fromNumber,
                                    homeCountryId: params.homeCountryId,
                                });
                            this._webphoneInviteFromSDK = false;
                            // @ts-ignore
                            return [2 /*return*/, this._onWebPhoneSessionInvite(webphoneSession)];
                        }
                        callParams = {};
                        if (params.toNumber.length > 5) {
                            callParams.phoneNumber = params.toNumber;
                        }
                        else {
                            callParams.extensionNumber = params.toNumber;
                        }
                        return [4 /*yield*/, this._callControl.createCall(params.deviceId, callParams)];
                    case 1:
                        telephonySession = _a.sent();
                        return [2 /*return*/, this._onNewTelephonySession(telephonySession)];
                }
            });
        });
    };
    RingCentralCall.prototype.pickupInboundCall = function (_a) {
        var sessionId = _a.sessionId, toNumber = _a.toNumber, fromNumber = _a.fromNumber, serverId = _a.serverId, telephonySessionId = _a.telephonySessionId, sessionDescriptionHandlerOptions = _a.sessionDescriptionHandlerOptions;
        return __awaiter(this, void 0, void 0, function () {
            var session, extraHeaders, inviteOptions, webphoneSession;
            return __generator(this, function (_b) {
                if (!this.webphone) {
                    throw new Error('Web phone instance is required');
                }
                if (!this.webphoneRegistered) {
                    throw new Error('webphone is not registered');
                }
                session = this.sessions.find(function (s) { return s.id === telephonySessionId; });
                if (!session) {
                    throw new Error('call session was not found');
                }
                extraHeaders = [
                    "RC-call-type: inbound-pickup; session-id: " + sessionId + "; server-id: " + serverId,
                ];
                inviteOptions = {
                    sessionDescriptionHandlerOptions: sessionDescriptionHandlerOptions,
                    fromNumber: fromNumber,
                    extraHeaders: extraHeaders,
                };
                this._webphoneInviteFromSDK = true;
                webphoneSession = this._webphone &&
                    this._webphone.userAgent.invite(toNumber, inviteOptions);
                session.setWebphoneSession(webphoneSession);
                this._webphoneInviteFromSDK = false;
                this.emit(events.WEBPHONE_INVITE_SENT, webphoneSession);
                return [2 /*return*/, session];
            });
        });
    };
    RingCentralCall.prototype._onNewWebPhoneSession = function (webphoneSession) {
        var _this = this;
        var newSession = new Session_1.Session({
            webphoneSession: webphoneSession,
        });
        var onSessionDisconnected = function () {
            _this._onSessionDisconnected(newSession);
            newSession.removeListener(Session_1.events.DISCONNECTED, onSessionDisconnected);
        };
        newSession.on(Session_1.events.DISCONNECTED, onSessionDisconnected);
        this._sessions.push(newSession);
        return newSession;
    };
    RingCentralCall.prototype._onWebPhoneSessionInvite = function (webphoneSession) {
        this.emit(events.WEBPHONE_INVITE_SENT, webphoneSession);
        var session = this._getSessionFromWebphoneSession(webphoneSession);
        if (session && session.webphoneSession) {
            return session;
        }
        // @ts-ignore
        if (!webphoneSession.__rc_direction) {
            // @ts-ignore
            webphoneSession.__rc_direction = Session_1.directions.OUTBOUND;
        }
        if (session) {
            session.setWebphoneSession(webphoneSession);
            return session;
        }
        session = this._onNewWebPhoneSession(webphoneSession);
        this.emit(events.NEW, session);
        return session;
    };
    RingCentralCall.prototype._getSessionFromWebphoneSession = function (webphoneSession) {
        var partyData = utils_1.extractHeadersData(webphoneSession.request.headers)[0];
        var telephonySessionId = partyData && partyData.sessionId;
        if (telephonySessionId) {
            return this.sessions.find(function (s) { return s.telephonySessionId === telephonySessionId; });
        }
        return this.sessions.find(function (s) { return s.webphoneSession === webphoneSession; });
    };
    RingCentralCall.prototype._onSessionDisconnected = function (session) {
        this._sessions = this._sessions.filter(function (s) { return s !== session; });
        session.dispose();
    };
    RingCentralCall.prototype.setWebphone = function (webphone) {
        this._clearWebphone();
        this._webphone = webphone;
        this._webphoneRegistered = webphone.userAgent.registerContext.registered;
        this._webphone.userAgent.on('invite', this._onWebPhoneSessionRing);
        this._webphone.userAgent.on('inviteSent', this._onWebPhoneSessionInviteSent);
        this._webphone.userAgent.on('registered', this._onWebphoneRegistered);
        this._webphone.userAgent.on('unregistered', this._onWebphoneUnregistered);
        this._webphone.userAgent.on('registrationFailed', this._onWebphoneRegistrationFailed);
    };
    RingCentralCall.prototype.removeWebphone = function () {
        this._clearWebphone();
    };
    RingCentralCall.prototype._clearWebphone = function () {
        if (!this._webphone) {
            return;
        }
        this._webphone.userAgent.removeListener('invite', this._onWebPhoneSessionRing);
        this._webphone.userAgent.removeListener('inviteSent', this._onWebPhoneSessionInviteSent);
        this._webphone.userAgent.removeListener('registered', this._onWebphoneRegistered);
        this._webphone.userAgent.removeListener('unregistered', this._onWebphoneUnregistered);
        this._webphone.userAgent.removeListener('registrationFailed', this._onWebphoneRegistrationFailed);
        this._webphone = null;
        this._webphoneRegistered = false;
    };
    RingCentralCall.prototype.initCallControl = function (sdk) {
        this._clearCallControl();
        this._callControl = new ringcentral_call_control_1.RingCentralCallControl(__assign({ sdk: sdk, userAgent: this._userAgent }, this._callControlOptions));
        if (this._enableSubscriptionHander) {
            this._handleSubscription();
        }
        else {
            this._callControlNotificationReady = true;
        }
        this._callControl.on('new', this._onNewTelephonySession);
        this._callControl.on('initialized', this._onCallControlInitialized);
    };
    RingCentralCall.prototype._handleSubscription = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cachedSubscriptionData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._subscriptions) {
                            this._subscription = this._subscriptions.createSubscription();
                            // @ts-ignore
                        }
                        else if (typeof this._sdk.createSubscription === 'function') {
                            // @ts-ignore
                            this._subscription = this._sdk.createSubscription(); // For support RC JS SDK V3
                        }
                        else {
                            throw new Error('Init Error: subscriptions instance is required');
                        }
                        return [4 /*yield*/, this._sdk
                                .cache()
                                .getItem(this._subscriptionCacheKey)];
                    case 1:
                        cachedSubscriptionData = _a.sent();
                        this._subscriptionEventFilters = [
                            '/restapi/v1.0/account/~/extension/~/telephony/sessions',
                        ];
                        if (cachedSubscriptionData) {
                            try {
                                this._subscription.setSubscription(cachedSubscriptionData); // use the cache
                            }
                            catch (e) {
                                console.error('Cannot set subscription from cache data', e);
                                this._subscription.setEventFilters(this._subscriptionEventFilters);
                            }
                        }
                        else {
                            this._subscription.setEventFilters(this._subscriptionEventFilters);
                        }
                        this._subscription.on(this._subscription.events.subscribeSuccess, this._onSubscriptionCreateSuccess);
                        this._subscription.on(this._subscription.events.renewSuccess, this._onSubscriptionCreateSuccess);
                        this._subscription.on(this._subscription.events.notification, this.onNotificationEvent);
                        this._subscription.on(this._subscription.events.renewError, this._onSubscriptionRenewFail);
                        this._subscription.on(this._subscription.events.automaticRenewError, this._onSubscriptionAutomaticRenewError);
                        this._subscription.on(this._subscription.events.subscribeError, this._onSubscriptionCreateError);
                        return [2 /*return*/, this._subscription.register()];
                }
            });
        });
    };
    RingCentralCall.prototype._clearSubscriptionHander = function () {
        if (!this._subscription) {
            return;
        }
        this._subscription.removeListener(this._subscription.events.subscribeSuccess, this._onSubscriptionCreateSuccess);
        this._subscription.removeListener(this._subscription.events.renewSuccess, this._onSubscriptionCreateSuccess);
        this._subscription.removeListener(this._subscription.events.notification, this.onNotificationEvent);
        this._subscription.removeListener(this._subscription.events.renewError, this._onSubscriptionRenewFail);
        this._subscription.removeListener(this._subscription.events.automaticRenewError, this._onSubscriptionAutomaticRenewError);
        this._subscription.removeListener(this._subscription.events.subscribeError, this._onSubscriptionCreateError);
        this._subscription = null;
    };
    RingCentralCall.prototype._clearCallControl = function () {
        if (!this._callControl) {
            return;
        }
        this._callControl.removeListener('new', this._onNewTelephonySession);
        this._callControl = null;
    };
    RingCentralCall.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._clearWebphone();
                this._clearCallControl();
                this._clearSubscriptionHander();
                this.removeAllListeners();
                this.sessions.forEach(function (session) {
                    session.hangup();
                });
                this._sessions = [];
                return [2 /*return*/];
            });
        });
    };
    RingCentralCall.prototype.refreshDevices = function () {
        return this._callControl.refreshDevices();
    };
    /**
     *  Switch call voice transmission from other tabs or devices to current tab
     */
    RingCentralCall.prototype.switchCall = function (telephonySessionId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var presenceRes, presence, activeCalls, activeCall;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sdk.platform().get('/restapi/v1.0/account/~/extension/~/presence?sipData=true&detailedTelephonyPresence=true')];
                    case 1:
                        presenceRes = _a.sent();
                        return [4 /*yield*/, presenceRes.json()];
                    case 2:
                        presence = _a.sent();
                        activeCalls = presence.activeCalls;
                        activeCall = activeCalls.find(function (call) { return call.telephonySessionId === telephonySessionId; });
                        return [2 /*return*/, this.switchCallFromActiveCall(activeCall, options)];
                }
            });
        });
    };
    RingCentralCall.prototype.switchCallFromActiveCall = function (activeCall, options) {
        if (!this.webphone) {
            throw new Error('Webphone instance is required.');
        }
        if (!this.webphoneRegistered) {
            throw new Error('Webphone instance is not unregistered now.');
        }
        var session = this.sessions.find(function (s) { return s.id === activeCall.telephonySessionId; });
        if (!session) {
            throw new Error('Telephony Session isn\'t existed.');
        }
        if (session.webphoneSession) {
            throw new Error('The call is in current instance');
        }
        this._webphoneInviteFromSDK = true;
        var webphoneSession = this.webphone.userAgent.switchFrom(activeCall, options);
        session.setWebphoneSession(webphoneSession);
        this._webphoneInviteFromSDK = false;
        return this._onWebPhoneSessionInvite(webphoneSession);
    };
    Object.defineProperty(RingCentralCall.prototype, "webphone", {
        get: function () {
            return this._webphone;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingCentralCall.prototype, "callControl", {
        get: function () {
            return this._callControl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingCentralCall.prototype, "sessions", {
        get: function () {
            return this._sessions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingCentralCall.prototype, "webphoneRegistered", {
        get: function () {
            return this._webphoneRegistered;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingCentralCall.prototype, "callControlReady", {
        get: function () {
            return this._callControl.ready;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingCentralCall.prototype, "callControlNotificationReady", {
        get: function () {
            return this._callControlNotificationReady;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RingCentralCall.prototype, "devices", {
        get: function () {
            return this._callControl.devices || [];
        },
        enumerable: false,
        configurable: true
    });
    return RingCentralCall;
}(events_1.EventEmitter));
exports.RingCentralCall = RingCentralCall;
//# sourceMappingURL=RingCentralCall.js.map